import * as React from "react";
import { useLocation } from "react-router-dom";
import { normalizeQuery } from "../organisationResult/util";
import { usePageEnvelope } from "./PageEnvelope";

export interface OrganisationSearchQueryState {
  keyword?: null | string;
  where?: null | string;
  category?: number[];
  page?: null | number;
}

export const defaultOrganisationSearchQuery = {
  keyword: null,
  where: null,
  category: [],
  page: null,
};

export const OrganisationSearchQueryStateContext = React.createContext<
  OrganisationSearchQueryState | undefined
>(undefined);

export const OrganisationSearchQueryProvider: React.FC<{}> = ({ children }) => {
  const location = useLocation<{
    searchQuery?: OrganisationSearchQueryState;
  }>();

  const { pageEnvelope } = usePageEnvelope<{
    searchCriteria?: OrganisationSearchQueryState;
  }>();

  const searchQuery = React.useMemo(() => {
    return normalizeQuery(
      Object.assign(
        {},
        defaultOrganisationSearchQuery,
        location.state?.searchQuery ||
          pageEnvelope.data?.searchCriteria ||
          defaultOrganisationSearchQuery
      )
    );
  }, [location.state, pageEnvelope.data]);

  return (
    <OrganisationSearchQueryStateContext.Provider value={searchQuery}>
      {children}
    </OrganisationSearchQueryStateContext.Provider>
  );
};

export const useOrganisationSearchQuery = (): OrganisationSearchQueryState => {
  const searchQuery = React.useContext(OrganisationSearchQueryStateContext);
  return searchQuery;
};

export default OrganisationSearchQueryStateContext;
